<template>
  <div class="user-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/orders' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>地址</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-row :gutter="10" class="mb8">
          <el-col :span="1.5">
            <el-button
                type="primary"
                plain
                icon="el-icon-plus"
                size="mini"
                @click="handleAdd"
            >新增</el-button>
          </el-col>
          <el-col :span="1.5">
            <el-button
                type="success"
                plain
                icon="el-icon-edit"
                size="mini"
                :disabled="single"
                @click="handleUpdate"
            >修改</el-button>
          </el-col>
          <el-col :span="1.5">
            <el-button
                type="danger"
                plain
                icon="el-icon-delete"
                size="mini"
                :disabled="multiple"
                @click="handleDelete"
            >删除</el-button>
          </el-col>
          <el-col :span="1.5">
            <el-button
                type="primary"
                size="mini"
                @click="handleQuery"
            >搜索</el-button>
          </el-col>
        </el-row>
      </div>
      <div slot="table" class="full-height display-col">
        <el-table v-loading="loading" :data="TaobaoPurchaseOrderAddressList" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55" align="center" />
          <el-table-column label="邮政编码" align="center" prop="receiverZip" />
          <el-table-column label="国家" align="center" prop="receiverCountry" />
          <el-table-column label="省、直辖市、自治区" width="160px" align="center" prop="receiverState" />
          <el-table-column label="市" align="center" prop="receiverCity" />
          <el-table-column label="县、区、县级市" align="center" prop="receiverDistrict" />
          <el-table-column label="手机号码" align="center" prop="receiverMobilePhone" />
          <el-table-column label="姓名" align="center" prop="receiverName" />
          <el-table-column label="电话号码" align="center" prop="receiverPhone" />
          <el-table-column label="详细地址 " align="center" prop="receiverAddress" />
          <el-table-column label="操作" align="center" width="160px" class-name="small-padding fixed-width">
            <template slot-scope="scope">
              <el-button
                  size="mini"
                  type="primary"
                  @click="handleUpdate(scope.row)"
              >修改</el-button>
              <el-button
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.row)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryParams.pageNum"
            :page-sizes="[5, 10, 20, 50, 100, 200]"
            :page-size="queryParams.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>
      </div>
    </table-con>
    <!-- 添加或修改淘天采购订单地址维护对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="500px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="邮政编码" prop="receiverZip">
          <el-input v-model="form.receiverZip" placeholder="请输入邮政编码" />
        </el-form-item>
        <el-form-item label="国家" prop="receiverCountry">
          <el-input v-model="form.receiverCountry" placeholder="请输入国家" />
        </el-form-item>
        <el-form-item label="省" prop="receiverState">
          <el-input v-model="form.receiverState" placeholder="请输入省、直辖市、自治区" />
        </el-form-item>
        <el-form-item label="市" prop="receiverCity">
          <el-input v-model="form.receiverCity" placeholder="请输入市" />
        </el-form-item>
        <el-form-item label="区" prop="receiverDistrict">
          <el-input v-model="form.receiverDistrict" placeholder="请输入县、区、县级市" />
        </el-form-item>
        <el-form-item label="手机号码" prop="receiverMobilePhone">
          <el-input v-model="form.receiverMobilePhone" placeholder="请输入手机号码" />
        </el-form-item>
        <el-form-item label="姓名" prop="receiverName">
          <el-input v-model="form.receiverName" placeholder="请输入姓名" />
        </el-form-item>
        <el-form-item label="电话号码" prop="receiverPhone">
          <el-input v-model="form.receiverPhone" placeholder="请输入电话号码" />
        </el-form-item>
        <el-form-item label="详细地址" prop="receiverAddress">
          <el-input v-model="form.receiverAddress" placeholder="请输入详细地址" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "TaobaoPurchaseOrderAddress",
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 淘天采购订单地址维护表格数据
      TaobaoPurchaseOrderAddressList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
      // 表单参数
      form: {},
      // 表单校验
      // 校验规则
      rules: {
        receiverZip: [
          { required: true, message: '请输入邮政编码', trigger: 'blur' },
          { pattern: /^[0-9]{6}$/, message: '邮政编码格式不正确', trigger: 'blur' }
        ],
        receiverCountry: [
          { required: true, message: '请输入国家', trigger: 'blur' }
        ],
        receiverState: [
          { required: true, message: '请输入省、直辖市、自治区', trigger: 'blur' }
        ],
        receiverCity: [
          { required: true, message: '请输入市', trigger: 'blur' }
        ],
        receiverDistrict: [
          { required: false, message: '请输入县、区、县级市', trigger: 'blur' }
        ],
        receiverMobilePhone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号码格式不正确', trigger: 'blur' }
        ],
        receiverName: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        receiverPhone: [
          { required: false, message: '请输入电话号码', trigger: 'blur' },
          { pattern: /^[0-9]{3,4}-[0-9]{7,8}$/, message: '电话号码格式不正确', trigger: 'blur' }
        ],
        receiverAddress: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ]
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    handleCurrentChange (newPage) {
      this.queryParams.pageNum = newPage
      this.getList()
    },
    handleSizeChange (newSize) {
      this.queryParams.pageSize = newSize
      this.getList()
    },
    /** 查询淘天采购订单地址维护列表 */
    getList() {
      this.loading = true;
      const params = {
        ...this.queryParams
      }
      this.$http.get("/taobaoShop/addressList", {params}).then(response => {
        this.TaobaoPurchaseOrderAddressList = response.data.data.list;
        this.total = response.data.data.total;
        this.loading = false;
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        receiverZip: null,
        receiverCountry: null,
        receiverState: null,
        receiverCity: null,
        receiverDistrict: null,
        receiverMobilePhone: null,
        receiverName: null,
        receiverPhone: null,
        receiverAddress: null,
      };
      // this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length!==1
      this.multiple = !selection.length
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加淘天采购订单地址维护";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const id = row.id || this.ids
      this.$http.get(`/taobaoShop/getAddress/${id}`).then(response => {
        this.form = response.data.data;
        this.open = true;
        this.title = "修改淘天采购订单地址维护";
      });
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.id != null) {
            const params = {
              ...this.form
            }
            this.$http.post("/taobaoShop/addressEdit",params).then(response => {
              this.$message.success("修改成功");
              this.open = false;
              this.getList();
            });
          } else {
            const params = {
              ...this.form
            }
            this.$http.post("/taobaoShop/addressAdd",params).then(response => {
              this.$message.success("新增成功");
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      let ids = row.id || this.ids;
      if(typeof ids !== "object"){
        ids = [ids]
      }
      console.log(ids)
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const params = {
          idList: ids
        }
        const res = await this.$http.post(`/taobaoShop/addressDel`,params);
        console.log(res)
        if(res.data.code === 200){
            this.$message.success("删除成功");
            this.getList();
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
      // this.$confirm('是否确认删除淘天采购订单地址维护编号为"' + ids + '"的数据项？').then(function() {
      //   return this.$http.get("/system/taobaoAuthorize/list");
      // }).then(() => {
      //   this.getList();
      //   this.$message.success("删除成功");
      // }).catch(() => {});
    },
  }
}
</script>
<style scoped lang="less">

</style>